const outfits = [
    " Casual Chic: White button-up shirt, high-waisted jeans, and ankle boots.",
    " Bohemian Vibes: Flowy floral maxi dress, floppy hat, and strappy sandals.",
    " Business Professional: Tailored blazer, matching trousers, crisp white shirt, and heels.",
    " Athleisure: Leggings, graphic tee, bomber jacket, and sneakers.",
    " Preppy Look: Collared polo shirt, pleated skirt, cardigan, and loafers.",
    " Edgy Ensemble: Leather jacket, band tee, ripped jeans, and combat boots.",
    " Romantic Floral: Off-the-shoulder floral top, high-waisted shorts, and wedges.",
    " Classic Elegance: Little black dress, pearl necklace, pumps, and a clutch.",
    " Street Style: Oversized hoodie, distressed jeans, sneakers, and a baseball cap.",
    " Vintage Glam: Retro-inspired A-line dress, cat-eye sunglasses, and peep-toe heels.",
    " Boho-Chic: Cropped lace top, wide-leg pants, floppy hat, and sandals.",
    " Sophisticated Glamour: Silk blouse, tailored trousers, statement necklace, and stilettos.",
    " Casual Cool: Denim jacket, graphic tee, jogger pants, and sneakers.",
    " Summer Vibes: Off-the-shoulder top, denim shorts, straw hat, and sandals.",
    " Power Suit: Matching blazer and trousers, button-up shirt, and loafers.",
    " Sporty Chic: Bomber jacket, leggings, sneakers, and a baseball cap.",
    " Nautical Inspired: Striped top, white shorts, boat shoes, and a straw tote bag.",
    " Vintage-Inspired: High-waisted skirt, cropped cardigan, oxford shoes, and a headscarf.",
    " Effortlessly Stylish: Oversized sweater, skinny jeans, ankle boots, and a statement bag.",
    " Casual Elegance: Wrap dress, ballet flats, and delicate jewelry.",
    " Trendy and Eclectic: Statement jacket, printed top, leather skirt, and ankle boots.",
    " Chic Minimalism: White button-up blouse, black trousers, and pointed-toe flats.",
    " Casual Denim: Denim shirt, distressed jeans, sneakers, and a crossbody bag.",
    " Floral Romance: Flowy floral blouse, high-waisted skirt, and strappy sandals.",
    " Timeless Classics: Trench coat, striped top, black pants, and pumps.",
    " Urban Cool: Leather jacket, graphic tee, skinny jeans, and ankle boots.",
    " Boho-Chic Summer: Maxi dress, floppy hat, layered necklaces, and sandals.",
    " Office Chic: Pencil skirt, blouse, blazer, and pumps.",
    " Casual Athleisure: Hoodie, jogger pants, sneakers, and a baseball cap.",
    " Effortless Summer: Sundress, wide-brimmed hat, sandals, and a straw tote bag.",
    " Modern Power Suit: Structured blazer, wide-leg pants, button-up shirt, and heels.",
    " Street Style Edge: Leather jacket, graphic tee, ripped jeans, and combat boots.",
    " Feminine Elegance: Lace top, midi skirt, statement necklace, and heels.",
    " Classic Black and White: Black dress, white blazer, pumps, and a clutch.",
    " Sporty Casual: Track jacket, leggings, sneakers, and a baseball cap.",
    " Beachy Vibes: Linen top, denim shorts, floppy hat, and sandals.",
    " Polished Professional: Sheath dress, tailored blazer, pumps, and a tote bag.",
    " Casual Streetwear: Oversized hoodie, jogger pants, sneakers, and a baseball cap.",
    " Summer Boho: Flowy maxi dress, wide-brimmed hat, layered jewelry, and sandals.",
    " Minimalistic Chic: Oversized sweater, black skinny jeans, loafers, and a structured bag.",
    " Casual Glam: Sequin top, distressed jeans, heels, and a clutch.",
    " Retro-Inspired: High-waisted jeans, polka dot blouse, cat-eye sunglasses, and flats.",
    " Effortlessly Stylish: Turtleneck sweater, wide-leg pants, ankle boots, and a crossbody bag.",
    " Denim Love: Denim jacket, white tee, denim skirt, and sneakers.",
    " Floral Delight: Floral dress, straw hat, wedges, and a straw tote bag.",
    " Classic Monochrome: Black blazer, white blouse, tailored trousers, and pointed-toe flats.",
    " Edgy Street Style: Leather moto jacket, band tee, ripped jeans, and combat boots.",
    " Vintage-Inspired Glam: A-line dress, pearl necklace, retro sunglasses, and pumps.",
    " Bohemian Chic: Off-the-shoulder top, wide-leg pants, floppy hat, and strappy sandals.",
    " Sophisticated Elegance: Silk blouse, pleated skirt, statement necklace, and heels.",
    " Casual Coolness: Denim jacket, graphic tee, jogger pants, and sneakers.",
    " Summer Dream: Maxi dress, floppy hat, layered necklaces, and sandals.",
    " Powerfully Stylish: Pantsuit, button-up shirt, and loafers.",
    " Sporty and Trendy: Track jacket, leggings, sneakers, and a baseball cap.",
    " Nautical Charm: Striped top, white shorts, boat shoes, and a straw tote bag.",
    " Retro Glamour: High-waisted skirt, cropped cardigan, oxford shoes, and a headscarf.",
    " Effortlessly Chic: Oversized sweater, skinny jeans, ankle boots, and a statement bag.",
    " Elegant Simplicity: Wrap dress, ballet flats, delicate jewelry, and a clutch.",
    " Eclectic Fashion: Statement jacket, printed top, leather skirt, and ankle boots.",
    " Minimalist Sophistication: White button-up blouse, black trousers, pointed-toe flats.",
    " Denim Love: Denim shirt, distressed jeans, sneakers, and a crossbody bag.",
    " Romantic Florals: Flowy floral blouse, high-waisted skirt, strappy sandals.",
    " Timeless Classics: Trench coat, striped top, black pants, and pumps.",
    " Urban Coolness: Leather jacket, graphic tee, skinny jeans, and ankle boots.",
    " Boho-Chic Summer: Maxi dress, floppy hat, layered necklaces, and sandals.",
    " Office Chic: Pencil skirt, blouse, blazer, and pumps.",
    " Casual Athleisure: Hoodie, jogger pants, sneakers, and a baseball cap.",
    " Effortless Summer: Sundress, wide-brimmed hat, sandals, and a straw tote bag.",
    " Modern Power Suit: Structured blazer, wide-leg pants, button-up shirt, heels.",
    " Street Style Edge: Leather jacket, graphic tee, ripped jeans, combat boots.",
    " Feminine Elegance: Lace top, midi skirt, statement necklace, heels.",
    " Classic Black and White: Black dress, white blazer, pumps, clutch.",
    " Sporty Casual: Track jacket, leggings, sneakers, baseball cap.",
    " Beachy Vibes: Linen top, denim shorts, floppy hat, sandals.",
    " Polished Professional: Sheath dress, tailored blazer, pumps, tote bag.",
    " Casual Streetwear: Oversized hoodie, jogger pants, sneakers, baseball cap.",
    " Summer Boho: Flowy maxi dress, wide-brimmed hat, layered jewelry, sandals.",
    " Minimalistic Chic: Oversized sweater, black skinny jeans, loafers, structured bag.",
    " Casual Glam: Sequin top, distressed jeans, heels, clutch.",
    " Retro-Inspired: High-waisted jeans, polka dot blouse, cat-eye sunglasses, flats.",
    " Effortlessly Stylish: Turtleneck sweater, wide-leg pants, ankle boots, crossbody bag.",
    " Denim Love: Denim jacket, white tee, denim skirt, sneakers.",
    " Floral Delight: Floral dress, straw hat, wedges, straw tote bag.",
    " Classic Monochrome: Black blazer, white blouse, tailored trousers, pointed-toe flats.",
    " Edgy Street Style: Leather moto jacket, band tee, ripped jeans, combat boots.",
    " Vintage-Inspired Glam: A-line dress, pearl necklace, retro sunglasses, pumps.",
    " Bohemian Chic: Off-the-shoulder top, wide-leg pants, floppy hat, strappy sandals.",
    " Sophisticated Elegance: Silk blouse, pleated skirt, statement necklace, heels.",
    " Casual Coolness: Denim jacket, graphic tee, jogger pants, sneakers.",
    " Summer Dream: Maxi dress, floppy hat, layered necklaces, sandals.",
    " Powerfully Stylish: Pantsuit, button-up shirt, loafers.",
    " Sporty and Trendy: Track jacket, leggings, sneakers, baseball cap.",
    " Nautical Charm: Striped top, white shorts, boat shoes, straw tote bag.",
    " Retro Glamour: High-waisted skirt, cropped cardigan, oxford shoes, headscarf.",
    " Effortlessly Chic: Oversized sweater, skinny jeans, ankle boots, statement bag.",
    " Elegant Simplicity: Wrap dress, ballet flats, delicate jewelry, clutch.",
    " Eclectic Fashion: Statement jacket, printed top, leather skirt, ankle boots.",
    " Minimalist Sophistication: White button-up blouse, black trousers, pointed-toe flats.",
    " Denim Love: Denim shirt, distressed jeans, sneakers, crossbody bag.",
    " Romantic Florals: Flowy floral blouse, high-waisted skirt, strappy sandals.",
]

export default outfits